import { useEffect, useState } from 'react';

import { EVENT_SEARCH_LOADING } from '@/constants/common';

interface CustomEventDetail {
  loading: boolean;
}

export const useDispatchLoadingEvent = (loading: boolean) => {
  useEffect(() => {
    const event = new CustomEvent<CustomEventDetail>(EVENT_SEARCH_LOADING, {
      detail: { loading }
    });

    window.dispatchEvent(event);
  }, [loading]);
};

export const useLoadingEvent = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleCustomEvent = (event: CustomEvent<CustomEventDetail>): void => {
      setIsLoading(event.detail.loading);
    };

    window.addEventListener(
      EVENT_SEARCH_LOADING,
      handleCustomEvent as EventListener
    );

    return () => {
      window.removeEventListener(
        EVENT_SEARCH_LOADING,
        handleCustomEvent as EventListener
      );
    };
  }, []);

  return isLoading;
};
